module.exports = __webpack_public_path__ + "img/yezi6.5d2a95c4.png";